module.exports = __webpack_public_path__ + "img/VL_05_02.38fd4830.png";